import { ReactNode } from "react"
import { Project } from "../../../types"
import { Status } from "../status/Status"
import styles from "./status-item.module.css"
import { formatDate } from "@/lib/formatDate"

type Props = {
  status?: Project["status"]
  name: string
  plannedAt?: string
  plannedTo?: string
  subTitle?: ReactNode
  onClick: () => void
}
export const StatusItem = ({
  status,
  name,
  subTitle,
  plannedAt,
  plannedTo,
  onClick,
}: Props) => {
  const hasAnyPlannedDates = plannedAt != null || plannedTo != null
  return (
    <div className={styles.item} onClick={onClick}>
      <Status status={status} />
      <div className="flex items-center justify-between w-full">
        <div>
          <div className={styles.title}>{name}</div>
          {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
        </div>
        {hasAnyPlannedDates && (
          <div className="text-gray-500 text-[14px]">
            Plānots:{" "}
            {plannedAt ? formatDate(plannedAt, "dd.MMM yyyy") + " " : ""}
            {plannedTo ? "līdz " + formatDate(plannedTo, "dd.MMM yyyy") : ""}
          </div>
        )}
      </div>
    </div>
  )
}
